const staging = process.env.NODE_ENV !== 'production'

module.exports = {
  header: 'Login',
  headerThankYou: 'Thank you',
  isLoginLink: false,
  agentTitle: 'If you\'re a travel agent',
  agentCallToAction: 'Agent Login',
  agentLoginLocation: '/login.php',
  customerLoginLocation: '/customer-login.html',
  loginUnsuccessful: 'Login unsuccessful, please try the magic login link',
  customerTitle: 'Customer Login',
  emailAddress: 'Email Address',
  enterEmail: 'Enter your email address',
  password: 'Password',
  enterPassword: 'Enter password',
  customerCallToAction: (splitTestIsOn = false) => { return splitTestIsOn ? 'Log me in!' : 'Log in' },
  forgottenPassword: 'Forgotten password?',
  noValidUser: 'Oh no! We couldn’t find an account registered to that email address. Don’t worry, we can create you an account when you make your first booking.',
  magicLink: 'Forgotten Password. Email me a magic sign in link.',
  magicLinkUrl: 'X0Gzc2X%3DYQpglLjHJlYQGszei3FqTzgcrWhLC6rgwkGMmzaaUc4ERlbUk9CDRVwjpnpgHlpgneHmgJoXX0Gzc2X%3DYQpglLjHJlYQGkXTumvmw5tFLCtiihzazcPL8zaaUc4ERlbUk9CDR',
  magicLinkSent: 'Please check your inbox, we have sent your magic link login.',
  createAccountLink: `https://create-account${staging ? '-staging' : ''}.holidayextras.co.uk/validate`,
  customerLogout: 'Logout',
  hello: 'Hello',
  your_account: 'Your Account',
  yourBookings: 'Your bookings',
  tripsAndBookings: {
    url: '/static/#/mytrips',
    label: 'Trips & Bookings'
  },
  personalDetails: {
    url: '/static/?#/users/edit?lang=en',
    label: 'Personal details'
  },
  welcomeBackMsg: 'Welcome back',
  welcomeBackMsgText: 'If there is anything we can do please hit <a href="/help-and-support.html">Help & Support</a>.<br />We really do value your business.',
  incorrectEmailPassword: 'Incorrect email or password',
  goodEvening: 'Good evening',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  heyWelcomeBack: 'Hey[NAME]! Welcome back to <div class="no-wrap">Holiday Extras 👋</div>',
  loginPopoverSell1: 'We exist for one simple purpose: to give you <i class="no-wrap">less hassle</i> so you can have <i class="no-wrap">more holiday</i>.',
  loginPopoverSell2: 'Quicker and easier booking with your saved details at the ready!',
  noAccountMessage: '<strong>Don\'t have an account?</strong> You can <a href="/details-form-view.html" data-hxtrack-name="login-form-dont_have_account">lookup your booking</a> using your booking reference and your email address'
}



// WEBPACK FOOTER //
// ./shared/config/navigation/login/uk/index.js